var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style["m-partner"] }, [
    _c("div", { staticClass: "m-container" }, [
      _c("div", { class: _vm.$style["container-inner"] }, [
        _c("div", { ref: "listWrapper", class: _vm.$style["partner-list"] }, [
          _c(
            "div",
            {
              ref: "listBox",
              staticClass: "grid grid-flow-col-dense",
              class: _vm.$style["list-inner"]
            },
            _vm._l(_vm.runList, function(item, index) {
              return _c(
                "div",
                { key: index, class: _vm.$style["partner-item"] },
                [
                  _c("div", { class: _vm.$style["img-box"] }, [
                    _c("img", { attrs: { src: item.thumb } })
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f2fd646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f2fd646","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/index/PartnerModule.vue
// module id = Iby/
// module chunks = 0